<!-- Main container -->
<div class="layout-col full">
  <elder-table class="flex" matSort [data]="data" [idField]="'id'" (itemClick)="openDetail($event)">
    <elder-data-toolbar
      *elderTableToolbar
      (requestNew)="create()"
      [canRemove]="false"
      [canAdd]="false"
      [canMore]="false"
    >
      <ng-template elderToolbarContent="center">
        <elder-search-box
          dense
          class="flex-60 pt-xs"
          queryKey="query"
          [autoPanel]="false"
          [elderSearchContext]="data.filter"
          [forcedFilters]="forcedFilters$ | async"
        >
        </elder-search-box>
      </ng-template>
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>label</mat-icon>
      </td>
    </ng-container>

    <!-- id Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.id' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">{{ property.id }}</td>
    </ng-container>

    <!-- type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.type' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">{{ property.type }}</td>
    </ng-container>

    <!-- values Column -->
    <ng-container matColumnDef="values">
      <th mat-header-cell *matHeaderCellDef style="width: 25%">
        {{ 'context.config' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">
        @if (
          property.type === PropertyType.VALUE_ENUMERATION ||
          property.type === PropertyType.QUANTITY_ENUMERATION
        ) {
          <span>
            {{ property.values.toString() | elderTruncate: 50 }}
          </span>
        }

        @if (
          property.type === PropertyType.QUANTITY || property.type === PropertyType.QUANTITY_LIST
        ) {
          <span>
            {{ property.unit }}
          </span>
        }

        @if (property.type === PropertyType.QUANTITY_ENUMERATION && property.unit) {
          <span class="p-sm"> [{{ property.unit }}] </span>
        }
      </td>
    </ng-container>

    <!-- default value -->
    <ng-container matColumnDef="defaultValue">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.defaultValue' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">{{ property.defaultValue }}</td>
    </ng-container>

    <!-- roundingMode Column -->
    <ng-container matColumnDef="roundingMode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.roundingMode' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">
        @if (property.supportsPrecision) {
          <span>{{ renderRoundingMode(property) }}</span>
        }
      </td>
    </ng-container>
    <!-- precision Column -->
    <ng-container matColumnDef="precision">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.precision' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">
        @if (property.supportsPrecision) {
          <span>{{ property.precision ?? 'context.absolute' | translate }}</span>
        }
      </td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">{{ property.description }}</td>
    </ng-container>

    <!-- path Column -->
    <ng-container matColumnDef="propertyPath">
      <th mat-header-cell *matHeaderCellDef style="width: 5%" mat-sort-header>
        {{ 'Path' | translate }}
      </th>
      <td mat-cell *matCellDef="let property">
        @if (property.propertyPath) {
          <mat-icon>check</mat-icon>
        }
      </td>
    </ng-container>
  </elder-table>
</div>
